import { render, staticRenderFns } from "./ModalConnect.vue?vue&type=template&id=3b199992"
import script from "./ModalConnect.vue?vue&type=script&lang=js"
export * from "./ModalConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports